module.exports = __webpack_public_path__ + "media/images/pic/teachers/weronika-smorag-8e92cdaa656a358aea9bf3218754e943.png";